import { getGlobalSettings } from "@utilities/getGlobalSettings";
import { useRouter } from "next/router";
import PageComponent from "../components/Page/Page";
import {
  DEFAULT_CONTENTFUL_INCLUDE,
  getPageProps,
} from "../utils/cms/ContentfulService";

export default function Page(props) {
  const { globalContent, pageContent, settings, programmeData, preview } =
    props;

  const router = useRouter();

  return (
    <PageComponent
      props={{
        globalContent,
        pageContent,
        settings,
        programmeData,
        preview,
        canonicalUrl: router.asPath,
      }}
    />
  );
}

export async function getStaticProps({ preview }) {
  try {
    const { footer, siteHeader, tags, settings } = await getGlobalSettings();
    const { programmeSettings, siteSettings, publicationSettings } = settings;

    // get 404 content
    const { globalContent, pageContent } = await getPageProps({
      slug: "404",
      contentType: ["eeLandingPage"],
      globals: [],
      include: DEFAULT_CONTENTFUL_INCLUDE,
      allTags: tags,
      preview,
    });

    // https://github.com/vercel/next.js/discussions/10992#discussioncomment-103826
    return {
      // Revalidate 4 times a day
      revalidate: 60 * 60 * 6,
      props: {
        globalContent: { ...globalContent, footer, siteHeader },
        pageContent,
        settings: { programmeSettings, siteSettings, publicationSettings },
        ...(!!preview && { preview: true }),
      },
    };
  } catch {
    return { props: {} };
  }
}
